import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
  },
  containerList: {
    marginTop: theme.spacing(4),
    backgroundColor: theme.palette.background.paper,
  },
}));

export default useStyles;
